import type { Post } from '@/core/models/post';
import type { FeedOrderKey } from '@/core/models/preferences';

/** Only reorders the selected tab's posts; never changes its membership. */
export function orderFeed(posts: Post[], order: FeedOrderKey): Post[] {
  if (order === 'default') return posts;
  // The stored key keeps its old name; Likes were merged into Cherish.
  if (order === 'most-liked') return [...posts].sort((a, b) => b.cheers - a.cheers);
  // Legacy posts without a creation date keep their slots. Inventing a date
  // from a relative label would make the order drift as the page stays open.
  const dated = posts.filter((p) => Number.isFinite(Date.parse(p.createdAt ?? '')));
  dated.sort(
    (a, b) => (Date.parse(a.createdAt!) - Date.parse(b.createdAt!)) * (order === 'oldest' ? 1 : -1),
  );
  let next = 0;
  return posts.map((p) => (Number.isFinite(Date.parse(p.createdAt ?? '')) ? dated[next++]! : p));
}
